// extracted by mini-css-extract-plugin
module.exports = {"soundError":"add-sound_soundError__24_2M","mp3Uploader":"add-sound_mp3Uploader__2JFoM","mp3Container":"add-sound_mp3Container__1N6Hv"};